export type IntegrationProvider = 'gmail' | 'google_calendar' | 'slack';
export interface IntegrationPolicyEntry {
  allowed?: boolean;
}

export type WorkspaceIntegrationsPolicy = Partial<Record<IntegrationProvider, IntegrationPolicyEntry>>;

export interface IntegrationPolicyRow {
  provider: IntegrationProvider;
  icon: string;
  providerLabel: string;
  allowed: boolean;
}

export const ACTIVE_INTEGRATION_PROVIDERS: readonly IntegrationProvider[] = ['gmail', 'google_calendar', 'slack'];
export const GHOST_INTEGRATION_PROVIDERS: readonly IntegrationProvider[] = [];

const PROVIDER_ICONS: Record<IntegrationProvider, string> = {
  gmail: 'mail',
  google_calendar: 'calendar_month',
  slack: 'hub',
};

const PROVIDER_LABELS: Record<IntegrationProvider, string> = {
  gmail: 'Gmail',
  google_calendar: 'Google Calendar',
  slack: 'Slack',
};

export function presentIntegrationPolicyRow(
  provider: IntegrationProvider,
  policy: WorkspaceIntegrationsPolicy,
): IntegrationPolicyRow {
  const entry = policy[provider] ?? {};
  return {
    provider,
    icon: PROVIDER_ICONS[provider],
    providerLabel: PROVIDER_LABELS[provider],
    allowed: entry.allowed ?? true,
  };
}
